import {
    TypedUseSelectorHook,
    useDispatch as dispatchHook,
    useSelector as selectorHook
  } from 'react-redux';
  import { AppDispatch, RootState } from './types/types';
  
  export const useDispatch = () => dispatchHook<AppDispatch>();
  export const useSelector: TypedUseSelectorHook<RootState> = selectorHook;